import PropTypes from 'prop-types';
import React from 'react';
import { Checkbox } from 'react-toolbox';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import InputCell from 'components/LineItemTable/inputCell';
import DropDownCell from 'components/LineItemTable/dropDownCell';
import phaseLineItemShape from 'types/lineItemPropType';
import { titleize } from '../../../../../utils';
import RTCheckbox from 'styles/checkbox.scss';
import formStyles from 'styles/form';
import Editable from 'mixins/editable';


const formatOptions = options => options.map(value => ({ value, label: titleize(value) }));
const KIND_OPTIONS = formatOptions(['Labor', 'Product']);
const CATEGORY_OPTIONS = formatOptions(['', 'lead_assessment', 'pad', 'mileage']);
const SURFACE_TYPE_OPTIONS = formatOptions(['', 'All', 'Hardwood', 'Carpet', 'Tile', 'Laminate', 'Vinyl', 'Vinyl Plank', 'Backsplash', 'Pro Direct', 'Multi']);

class LineItemRow extends Editable(React.Component) {
  state = { ...this.props.lineItem };

  handleSave = () => this.props.onSave(this.state);

  handleChange = attr => val => this.setState({ [attr]: val.target ? val.target.value : val });

  handleItemNumberChange = this.handleChange('item_number');
  handleDescriptionChange = this.handleChange('description');
  handleNetPayableChange = this.handleChange('net_payable');
  handlePayableChange = this.handleChange('payable');
  handleActiveChange = this.handleChange('active');
  handleKindChange = this.handleChange('kind');
  handleCategoryChange = this.handleChange('category');
  handleVendorTypeChange = this.handleChange('vendor');
  handleSurfaceTypeChange = this.handleChange('surface_type');
  handleAccountingIdChange = this.handleChange('accounting_id');

  handlePayableSave = val => this.setState({ payable: val }, this.handleSave);

  handleActiveSave = val => this.setState({ active: val }, this.handleSave);

  formatPercent = val => (val ? `${val}%` : '');

  renderPayable = () => {
    const value = (<Checkbox
      checked={this.state.payable}
      onChange={this.handlePayableSave}
      className={formStyles.checkboxListItem}
      theme={RTCheckbox}
    />);
    return (<EditableTableCell label="Payable" value={value} onChange={this.handlePayableChange}>
      {value}
    </EditableTableCell>);
  };

  renderActive = () => {
    const value = (<Checkbox
      checked={this.state.active}
      onChange={this.handleActiveSave}
      className={formStyles.checkboxListItem}
      theme={RTCheckbox}
    />);
    return (<EditableTableCell label="Active" value={value} onChange={this.handleActiveChange}>
      {value}
    </EditableTableCell>);
  };

  render = () => {
    const lineItem = this.state;
    const rowProps =
      { isNew: lineItem.id < 0, onSave: this.handleSave };
    const { vendorTypes } = this.props;
    const VENDOR_TYPE_OPTIONS = formatOptions(vendorTypes);
    return (<EditableTableRow key={lineItem.id} id={lineItem.id} {...rowProps}>
      <InputCell attr="item_number" label="Item Number" lineItem={lineItem} onChange={this.handleItemNumberChange} />
      <InputCell attr="description" label="Description" lineItem={lineItem} onChange={this.handleDescriptionChange} />
      <DropDownCell
        attr="kind"
        label="Type"
        lineItem={lineItem}
        options={KIND_OPTIONS}
        onChange={this.handleKindChange}
      />
      <DropDownCell
        attr="category"
        label="Category"
        lineItem={lineItem}
        options={CATEGORY_OPTIONS}
        onChange={this.handleCategoryChange}
      />
      <DropDownCell
        attr="vendor"
        label="Vendor"
        lineItem={lineItem}
        options={VENDOR_TYPE_OPTIONS}
        onChange={this.handleVendorTypeChange}
      />
      <DropDownCell
        attr="surface_type"
        label="Surface Type"
        lineItem={lineItem}
        options={SURFACE_TYPE_OPTIONS}
        onChange={this.handleSurfaceTypeChange}
      />
      <InputCell attr="accounting_id" label="Accounting Id" lineItem={lineItem} onChange={this.handleAccountingIdChange} />
      <InputCell attr="net_payable" cellValue={this.formatPercent(lineItem.net_payable)} label="Net Payable %" lineItem={lineItem} onChange={this.handleNetPayableChange} />
      {this.renderPayable()}
      {this.renderActive()}
    </EditableTableRow>);
  }
}

LineItemRow.propTypes = {
  lineItem: PropTypes.shape(phaseLineItemShape),
  vendorTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSave: PropTypes.func.isRequired,
};

LineItemRow.defaultProps = { lineItem: {} };

export default LineItemRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/lineItems/components/lineItemRow.jsx